import { connect } from "react-redux";
import TermsAndConditionsModal from "../../components/TermsAndConditionsModal/index.jsx";
import { toggleModal } from "../../actions/Modal/index.js";
import { getTermsUrl } from "../../helpers/index.js";

const mapStateToProps = (state) => ({
  isVisible: state.Modal.termsAndConditionsModalVisible,
  premierDeliveryProposition:
    state.PremierPageFrame.content.premierDeliveryProposition,
  assetsUrl: state.Environment.assetsUrl,
  termsUrl: getTermsUrl(
    state.CountrySelector.countryData.termsAndConditionsUrl
  ),
  returnFocus: state.Modal.returnFocus,
  countryData: state.CountrySelector.countryData,
});

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => {
    dispatch(toggleModal(false));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsAndConditionsModal);
